<template>
  <el-dialog
    :title="rowAlarm.cph + ' - ' + $t('map.baojijngxiangqing')"
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="90%"
    top="3vh"
    @close="clickFun('close')"
    @open="init_data"
    @opened="open_process"
    :destroy-on-close="true"
  >
    <div class="title mt-20">
      <span>▍</span>{{ $t("map.ditushipinxiangqing") }}
    </div>
    <div class="navMain">
      <div class="nav-l">
        <div :class="['item', item_idx == 1 ? 'act' : '']">
          <span>◇</span> {{ $t("map.dituguiji") }}
          <ul>
            <li
              :class="['item_sub', item_idx_sub == 1 ? 'sub_act' : '']"
              @click="clickPos()"
            >
              ▪ {{ $t("map.baojingfashengdian") }}
            </li>
            <li
              :class="['item_sub', item_idx_sub == 2 ? 'sub_act' : '']"
              @click="clickMap(10)"
            >
              ▪ {{ $t("map.baojingqian10fenzhong") }}
            </li>
            <!-- <li>报警前10分钟</li>
            <li> {{ $t("map.baoingqian30fenzhong") }}</li>
            <li> {{ $t("map.baojingqian60fenzhong") }}</li> -->
          </ul>
        </div>
        <div :class="['item', item_idx == 2 ? 'act' : '']" @click="clickEchart">
          <span>◇</span>{{ $t("map.suduquxian") }}
          <!-- <ul>
            <li @click="clickEchart">{{ $t("map.baojingqian10fenzhong") }}</li>
            <li> {{ $t("map.baoingqian30fenzhong") }}</li>
            <li> {{ $t("map.baojingqian60fenzhong") }}</li>
          </ul> -->
        </div>
        <div :class="['item', item_idx == 3 ? 'act' : '']" @click="clickBack">
          <span>◇</span>{{ $t("map.luxianghuifang") }}
          <!-- <ul>
            <li @click="clickBack">{{ $t("map.baojingqian10fenzhong") }}</li>
            <li> {{ $t("map.baoingqian30fenzhong") }}</li>
            <li> {{ $t("map.baojingqian60fenzhong") }}</li>
          </ul> -->
        </div>
        <div
          :class="['item', item_idx == 4 ? 'act' : '']"
          @click="clickMapVideo"
        >
          <span>◇</span>{{ $t("map.shishibofang") }}
        </div>
        <div :class="['item', item_idx == 5 ? 'act' : '']" @click="clickImg">
          <span>◇</span>{{ $t("map.baojingtupian") }}
        </div>
        <div :class="['item', item_idx == 6 ? 'act' : '']" @click="clickVideo">
          <span>◇</span>{{ $t("map.baojingshipin") }}
        </div>
      </div>
      <div class="nav-r">
        <div
          class="nav-row"
          style="align-items: center; justify-content: space-between"
        >
          <GpsVideo
            v-if="show_flag == 'back'"
            ref="video"
            :width="videoW"
            :height="videoH"
            style="margin: 0%"
          ></GpsVideo>
          <div v-if="show_flag == 'back'" class="mt50">
            <div @click="clickCloseCH" class="ch2">{{ $t("map.guanbi") }}</div>
            <div class="flex-row">
              <div
                @click="clickCH(idx + 1)"
                v-for="(it, idx) in ay_para"
                :key="'c' + idx"
                class="ch1"
              >
                <div class="ch">{{ it }}</div>
                <el-button
                  type="primary"
                  size="mini"
                  @click.stop="clickCHVideoDL(idx + 1)"
                  >{{ $t("map.xiazai") }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="show_flag == 'video'"
          style="
            width: 100%;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            class="img-it"
            v-for="(it, idx) in imgList"
            :key="'v' + idx"
            @click="showItem(idx)"
          >
            <!-- <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAmtJREFUeJzt2yFsU0EYwPF/yQyVVGOrZ1tJLSgS7GZYgoVgsKBYZiFBgWZTm8UyO2wt2NphEV8ubKMtr/e9u+/u3fd3S5fe5Ze77t5bH3ieZaMuv/T8/ekceJB4LtougdW6Fz69fhr1hqPR/3n2Or7XDJhGzSJfSzYApuxe7gEzNc810FABZ8BBjoG6buEaC6vwK3CdapChrsDQHHh5dHw2TjXA0AEBHpIQsQVASIjYCiAkQmwJEBIgtgYIPSO2CAg9IrYKCD0htgwIPSC2DghKRAeUohEd8G9RiA54u50Rh3o35uTmD7F3pLvkK1CZAyob0hZ+temFo+OzmPdbcuejYF2+ApU5oDIHVOaAyhxQmQMqc0BlDqjMGnAFXGDwpaC+sr4SOUHwzoEnwAK4bzqjHSthBYbOgbfAD6O5RGUNeLcV8AH4SCXb2noLb+oKuZhfAI+N57K10lbgza6Rbf0OwSyykgFDP5E/Nl+A38Zz+acaAEPfgTfIl8mLqSZAkG39GVmRv2ynItUGGFoiR54LjLd1rYAh87Nj7YBw++yYfTUOATB0BXzLPeiQAAEmuQcs9Upk18bIgzX7uQceAmC43Ev2LMi2agacAs+QLwSZVSPgGFlxC+uJQH2AM2TVmWzXddUCOAEOKfCZ5dIBx8Aj5HZ/kZUMOEVWXfaz3S6VCDhBPueyn+liKg3Q9EwXkzXgPnINW8SZLiZrwBfI3ZSiP+e2VcLNhGrxoAzAqnNAZQ6ozAGVOaAyB1TmgMocUJkDKnNAZQ6ozAGVOaAyB1TmgMocUJkDKnNAZV3/J3JJwc9qJKqKJ6W81vsD+L5a4o9yWtgAAAAASUVORK5CYII="
              alt="video"
            /> -->
            <div class="viv">
              <img :src="it.img" alt="video" />
              <div class="viv1">
                <svg
                  t="1727432012379"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4488"
                  width="30"
                  height="30"
                >
                  <path
                    d="M512 0c281.6 0 512 230.4 512 512S793.6 1024 512 1024 0 793.6 0 512 230.4 0 512 0z m0 42.65984C253.87008 42.65984 42.65984 253.87008 42.65984 512c0 258.12992 211.21024 469.34016 469.34016 469.34016 258.12992 0 469.34016-211.21024 469.34016-469.34016C981.34016 253.87008 770.12992 42.65984 512 42.65984z m-116.36736 356.51584c0-68.46464 49.88928-93.34784 108.42112-56.0128l173.48608 109.93664c58.55232 37.35552 58.55232 99.57376 0 141.06624l-173.4656 109.93664c-60.7232 37.35552-108.4416 12.45184-108.4416-55.99232z"
                    p-id="4489"
                    fill="#ffffff"
                  ></path>
                </svg>
              </div>
            </div>
            <!-- <img :src="it.path" :alt="it.cph" /> -->
          </div>
          <!-- <video
            :src="videoPath"
            autoplay="autoplay"
            muted="muted"
            :width="videoW"
            height="400"
            style="margin: 3%; margin-top: 5%"
            controls="controls"
            loop="loop"
          >
            您的浏览器不支持video标签
          </video>
          <el-button
            type="primary"
            size="default"
            @click="downloadFile(videoName, videoPath)"
            >{{ $t("map.xiazai") }}</el-button
          > -->
        </div>
        <div
          class="nav-row"
          v-if="show_flag == 'mapVideo'"
          style="justify-content: space-between; align-items: center"
        >
          <GpsVideo
            ref="mapVideo"
            :width="videoW"
            :height="videoH"
            style=""
          ></GpsVideo>
          <div class="mt50">
            <div @click="clickCloseCHVideo" class="ch2">
              {{ $t("map.guanbi") }}
            </div>
            <div
              @click="clickCHVideo(idx + 1)"
              v-for="(it, idx) in ay_para"
              :key="'c' + idx"
              class="ch"
            >
              {{ it }}
            </div>
          </div>
        </div>
        <div
          v-if="show_flag == 'img'"
          style="width: 100%; display: flex"
          class="imgList"
        >
          <div
            class="img-it"
            v-for="(it, idx) in imgList"
            :key="'v' + idx"
            @click="showItem(idx)"
          >
            <!-- <img
              v-if="it.type == 'video'"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAmtJREFUeJzt2yFsU0EYwPF/yQyVVGOrZ1tJLSgS7GZYgoVgsKBYZiFBgWZTm8UyO2wt2NphEV8ubKMtr/e9u+/u3fd3S5fe5Ze77t5bH3ieZaMuv/T8/ekceJB4LtougdW6Fz69fhr1hqPR/3n2Or7XDJhGzSJfSzYApuxe7gEzNc810FABZ8BBjoG6buEaC6vwK3CdapChrsDQHHh5dHw2TjXA0AEBHpIQsQVASIjYCiAkQmwJEBIgtgYIPSO2CAg9IrYKCD0htgwIPSC2DghKRAeUohEd8G9RiA54u50Rh3o35uTmD7F3pLvkK1CZAyob0hZ+temFo+OzmPdbcuejYF2+ApU5oDIHVOaAyhxQmQMqc0BlDqjMGnAFXGDwpaC+sr4SOUHwzoEnwAK4bzqjHSthBYbOgbfAD6O5RGUNeLcV8AH4SCXb2noLb+oKuZhfAI+N57K10lbgza6Rbf0OwSyykgFDP5E/Nl+A38Zz+acaAEPfgTfIl8mLqSZAkG39GVmRv2ynItUGGFoiR54LjLd1rYAh87Nj7YBw++yYfTUOATB0BXzLPeiQAAEmuQcs9Upk18bIgzX7uQceAmC43Ev2LMi2agacAs+QLwSZVSPgGFlxC+uJQH2AM2TVmWzXddUCOAEOKfCZ5dIBx8Aj5HZ/kZUMOEVWXfaz3S6VCDhBPueyn+liKg3Q9EwXkzXgPnINW8SZLiZrwBfI3ZSiP+e2VcLNhGrxoAzAqnNAZQ6ozAGVOaAyB1TmgMocUJkDKnNAZQ6ozAGVOaAyB1TmgMocUJkDKnNAZV3/J3JJwc9qJKqKJ6W81vsD+L5a4o9yWtgAAAAASUVORK5CYII="
              alt="video"
            /> -->
            <img :src="it.path" :alt="it.cph" />
          </div>
          <!-- <div
            v-for="(it, idx) in imgList"
            :key="idx"
            style="text-align: center; margin: 10px"
          >
            <el-image
              style="width: 150px; height: 100px"
              :src="it.path"
              :preview-src-list="[it.path]"
            >
            </el-image>
            <div @click="downloadFile(it.filename, it.path)">下载</div>
          </div> -->
        </div>
        <div
          v-if="show_flag == 'echart'"
          id="main"
          style="width: 100%; height: calc(100vh - 210px); margin-left: 10px"
        ></div>

        <GpsMap v-if="show_flag == 'map'" ref="historyMap" :mapExpID="-detail">
        </GpsMap>
      </div>
    </div>
    <!-- <div class="title mt20"><span>▍</span>{{ $t("map.baojingchuli") }}</div>
    <div></div> -->
    <!------------------------->
    <div class="Window_container" v-divdrag v-if="divShow" ref="divWin_win">
      <div class="Window_header Window_window_title">
        <span class="Window_title"
          >{{ $t("map.zhaopianchakan") }} （{{ $t("map.dangqiandi") }}
          {{ curr_img_idx + 1 }}{{ $t("map.zhanggong") }}{{ imgList.length
          }}{{ $t("map.zhang") }}）</span
        ><button type="button" class="Window_closebtn" style="width: 40px">
          <el-icon size="20" @click="divShow = false">
            <Close />
          </el-icon></button
        ><!---->
      </div>
      <div
        style="
          background-color: rgb(255, 255, 255);
          overflow: hidden;
          max-height: 585px;
          width: 700px;
        "
      >
        <div
          title=""
          class="MediaViewingWindow_content"
          style="max-height: 400px"
        >
          <video
            v-if="imgList[curr_img_idx].type == 'video'"
            controls
            width="650"
            height="400"
            :src="imgList[curr_img_idx].path"
          >
            Your browser does not support the video tag.
          </video>
          <img
            v-if="imgList[curr_img_idx].type == 'img'"
            :style="{ transform: `rotate(${rotation}deg)` }"
            :src="imgList[curr_img_idx].path"
            style="width: 100%; height: auto"
          />
          <div
            @click="img_prev"
            class="swiper-button-prev"
            v-if="curr_img_idx > 0"
          ></div>
          <div
            @click="img_next"
            class="swiper-button-next"
            v-if="curr_img_idx < imgList.length - 1"
          ></div>
        </div>
        <div class="MediaViewingWindow_details">
          <table class="MediaViewingWindow_table">
            <tr>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.chepai") }}
              </td>
              <td style="border-color: rgb(214, 214, 214)">
                {{ imgList[curr_img_idx].cph }}
              </td>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.zxbjsj_name") }}
              </td>
              <td style="border-color: rgb(214, 214, 214)">
                {{ imgList[curr_img_idx].time }}
              </td>
            </tr>
            <tr>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.yuanyin") }}
              </td>
              <td style="border-color: rgb(214, 214, 214)">
                {{ imgList[curr_img_idx].alarm }}
              </td>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.tongdao") }}
              </td>
              <td style="border-color: rgb(214, 214, 214)">
                {{ imgList[curr_img_idx].ch }}
              </td>
            </tr>
            <tr>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.qiye") }}
              </td>
              <td colspan="3" style="border-color: rgb(214, 214, 214)">
                {{ imgList[curr_img_idx].cpy }}
              </td>
              <!----><!---->
            </tr>
            <tr>
              <td
                class="MediaViewingWindow_tableName"
                style="
                  border-bottom: none rgb(214, 214, 214);
                  border-top-color: rgb(214, 214, 214);
                  border-right-color: rgb(214, 214, 214);
                  border-left-color: rgb(214, 214, 214);
                  background: rgb(240, 241, 243);
                "
              >
                {{ $t("map.bjwz_name") }}
              </td>
              <td
                colspan="3"
                style="
                  border-bottom: none rgb(214, 214, 214);
                  border-top-color: rgb(214, 214, 214);
                  border-right-color: rgb(214, 214, 214);
                  border-left-color: rgb(214, 214, 214);
                "
              >
                {{ imgList[curr_img_idx].addr }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="Window_footer_PRMYT">
        <div style="height: 50px">
          <button
            @click="rotateLeft"
            type="button"
            class="sy_button sy_button_primary"
            style="
              height: 32px;
              padding: 0px 10px;
              border-width: 1px;
              margin: 8px 0px 8px 4px;
              width: 80px;
              border-right-style: solid;
              border-right-color: rgb(255, 255, 255);
            "
          >
            <span class="iconfont icon-zuozhuan da"></span></button
          ><button
            @click="rotateRight"
            type="button"
            class="sy_button sy_button_primary"
            style="
              height: 32px;
              padding: 0px 10px;
              border-width: 1px;
              margin: 8px 0px;
              width: 80px;
              border-right-style: solid;
              border-right-color: rgb(255, 255, 255);
            "
          >
            <span class="iconfont icon-youzhuan da"></span></button
          ><button
            @click="rotateOrg"
            type="button"
            class="sy_button sy_button_primary"
            style="
              height: 32px;
              padding: 0px 10px;
              border-width: 1px;
              margin: 8px -4px 8px 0px;
              width: 80px;
              border-right-style: solid;
              border-right-color: rgb(255, 255, 255);
            "
          >
            <span class="iconfont icon-huanyuanss da"></span></button
          ><button
            type="button"
            class="sy_button sy_button_primary"
            style="
              height: 32px;
              padding: 0px 10px;
              border-width: 1px;
              margin: 8px 4px;
              width: 80px;
            "
          >
            <span
              @click="btnDownload"
              class="iconfont icon-baocun da"
            ></span></button
          ><button
            @click="divShow = false"
            type="button"
            class="sy_button sy_button_plain"
            style="
              height: 32px;
              padding: 0px 10px;
              border-width: 1px;
              margin: 8px 4px;
              width: 80px;
            "
          >
            <span class="iconfont icon-guanbi da2"></span>
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import GpsMap from "./GpsMapHistory.vue";
import * as echarts from "echarts";
import GpsVideo from "./GpsVideo.vue";
import moment from "moment";
import GpsSocket from "../utils/GpsSocket";
import { getHTTPURL } from "../utils/car";
export default {
  components: { GpsMap, GpsVideo },
  emits: ["ErpDialogEvent"],
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    rowAlarm: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isShow(val) {
      this.dialogFormVisible = val;
      // this.$nextTick(() => {
      //   // this.init_data();
      //   this.init_data([0], [""]);
      // });
    },
  },
  data() {
    return {
      item_idx_sub: 1,
      channel_prev: 0,
      divShow: false,
      curr_img_idx: 0,
      rotation: 0,

      item_idx: 0,
      videoName: "",
      videoPath: "",
      imgList: [],
      channel_id: 1,
      ay_para: [],
      videoW: window.innerWidth - 700,
      //videoH: window.innerHeight - 700,
      videoH: "calc(100vh - 250px)",
      show_flag: "map",
      dialogFormVisible: this.isShow,
    };
  },
  mounted() {
    // this.init_data();
    window.onresize = () => {
      return (() => {
        this.videoW = window.innerWidth - 700;
        //this.videoH = 700;
      })();
    };
  },
  methods: {
    open_process() {
      //做数据清空处理
      this.item_idx = 0;
      this.clickPos();
      this.imgList = [];

      this.$nextTick(() => {
        // if (this.$refs.historyMap) {
        //   this.$refs.historyMap.clearAll();
        // }
        if (document.getElementById("main")) {
          var myChart = echarts.init(document.getElementById("main"));
          if (myChart) {
            myChart.dispose();
          }
        }
      });
    },
    clickCloseCHVideo() {
      let sn = this.rowAlarm.dev_name;
      let video_ip = this.$store.getters.orderIp; //"www.xilihuala.top";
      let video_port = this.$store.getters.videoPlaybackPort; //"9500";

      let sn_org = sn;
      // sn = this.leftZeroPadding(sn, 11);

      if (this.channel_prev > 0) {
        GpsSocket.sendMsg("order", {
          deviceid: sn_org,
          order: "9102",
          content: this.channel_prev + ",0,0,0",
          // content: this.channel_prev + ",2,0,000000000000",
        });
        this.$refs["mapVideo"].destroy();
      }
    },
    clickCloseCH() {
      this.$api
        .tree_isOnline_device({ device_id: this.rowAlarm.dev_id })
        .then((res_online) => {
          if (res_online.data.st > 0) {
            //回放视频
            let sn = this.rowAlarm.dev_name;
            let video_ip = this.$store.getters.videoIp; //"www.xilihuala.top";
            let video_port = this.$store.getters.videoPlaybackPort; //"9500";

            let sn_org = sn;
            // sn = this.leftZeroPadding(sn, 11);

            if (this.channel_prev > 0) {
              GpsSocket.sendMsg("order", {
                deviceid: sn_org,
                order: "9202",
                content: this.channel_prev + ",2,0,000000000000",
              });
              this.$refs["video"].destroy();
            }
          } else {
            this.$alert("Offline");
          }
        });
    },
    showItem(idx) {
      this.curr_img_idx = idx;
      this.divShow = true;
      this.$nextTick(() => {
        const screenWidth = document.documentElement.clientWidth; // body当前宽度
        const centeredDiv = this.$refs.divWin_win;
        const leftOffset = (screenWidth - centeredDiv.offsetWidth) / 2;
        centeredDiv.style.left = leftOffset + "px";
      });
      this.$api
        .bdmap_get_gps_addr({
          lng: this.imgList[this.curr_img_idx].lng,
          lat: this.imgList[this.curr_img_idx].lat,
        })
        .then((res) => {
          // console.log(res.data);
          this.imgList[this.curr_img_idx].addr = res.data.formatted_address;
        });
    },
    img_prev() {
      if (this.curr_img_idx > 0) {
        this.curr_img_idx--;
      }
    },
    img_next() {
      if (this.curr_img_idx < this.imgList.length) {
        this.curr_img_idx++;
      }
    },
    rotateOrg() {
      this.rotation = 0;
    },
    rotateLeft() {
      this.rotation -= 90;
    },
    rotateRight() {
      this.rotation += 90;
    },
    clickCHVideoDL(channel_id) {
      // var dev_id = this.PrefixZero(this.row.devID, 12);
      let sn_org = this.rowAlarm.dev_name;

      let dev_id = this.leftZeroPadding(sn_org, 12);

      let e_time = moment(this.rowAlarm.gps_time)
        .add(7, "seconds")
        .format("YYYY-MM-DD HH:mm:ss");
      let s_time = moment(this.rowAlarm.gps_time)
        .subtract(8, "seconds")
        .format("YYYY-MM-DD HH:mm:ss");
      let dt_ss = moment(this.rowAlarm.gps_time).format("YYYYMMDD");

      // let channel = num; //parseInt(obj.ch);
      // this.channel_id = num;
      // let st = s_time.replace(/-/g, "").replace(/:/g, "").replace(/ /g, "");
      // let et = e_time.replace(/-/g, "").replace(/:/g, "").replace(/ /g, "");

      var obj = {
        deviceid: dev_id,
        order: "9206",
        content: {
          ftpip: "127.0.0.1",
          ftpport: 23333,
          ftpuser: "video",
          ftppwd: "video",
          ftppath: dt_ss + "/" + dev_id,
          sourcetype: "00",
          startdate: s_time,
          enddate: e_time,
          alarmflag: "00",
          bitsstreamtype: "01",
          memorytype: "01",
          channelno: channel_id,
          taskexecondition: "07",
        },
      };
      GpsSocket.sendMsg("order", obj);
      this.$alert(this.$t("map.caozuochenggong"));
    },
    clickCHVideo(channel_id) {
      this.$api
        .tree_isOnline_device({ device_id: this.rowAlarm.dev_id })
        .then((res_online) => {
          if (res_online.data.st > 0) {
            //关闭上一个通道
            // window.parent.back_socket(
            //   sn,
            //   "9102",
            //   $("#VidedList" + idx).data("channel") + ",0,0,0"
            // );

            let sn_org = this.rowAlarm.dev_name;

            let sn = this.leftZeroPadding(sn_org, 11);

            let video_ip = this.$store.getters.videoIp; //"www.xilihuala.top";
            let video_port = this.$store.getters.orderPort; //"9500";
            // let channel_id = 1;

            let video_ip_play = this.$store.getters.videoIp; //"test.cnms365.com";
            let video_port_play = this.$store.getters.videoPort; //4022;

            if (this.channel_prev > 0) {
              GpsSocket.sendMsg("order", {
                deviceid: sn_org,
                order: "9102",
                content: this.channel_prev + ",0,0,0",
              });
            }
            this.channel_prev = channel_id;

            // channel_id = idx + 1;
            GpsSocket.sendMsg("order", {
              deviceid: sn_org,
              order: "9101",
              content:
                video_ip + "," + video_port + ",0," + channel_id + ",0,1",
            });

            let url = this.get_video_url_map(
              video_ip_play,
              video_port_play,
              sn,
              channel_id
            );
            this.$refs["mapVideo"].playUrl(url);
          } else {
            //
            this.$alert("Offline");
          }
        });
    },
    downloadFile(fileName, url) {
      if (fileName == "") return;
      // let fileName = this.imgList[this.curr_img_idx].filename;
      // let url = this.imgList[this.curr_img_idx].path;
      this.$api.sys_url_download(url).then((res) => {
        // 处理返回的文件流
        const content = res.data;
        const blob = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });

        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    get_video_url_map(video_ip_play, video_port_play, sn, channel_id) {
      return (
        "https://" +
        video_ip_play +
        ":" +
        video_port_play +
        "/flv?port=10077&app=live&stream=" +
        sn +
        "_channel_" +
        channel_id
      );
    },
    leftZeroPadding(number, length) {
      return String(number).padStart(length, "0");
    },
    clickMapVideo() {
      this.item_idx = 4;
      let ay_para = this.rowAlarm.channels.split(",");
      this.ay_para = ay_para;
      this.show_flag = "mapVideo";
      this.channel_prev = 0;
    },
    clickVideo() {
      this.$api
        .tree_isOnline_device({ device_id: this.rowAlarm.dev_id })
        .then((res_online) => {
          if (res_online.data.st > 0) {
            this.item_idx = 6;
            this.show_flag = "video";
            this.imgList.splice(0);

            let query_list = {
              rp: 35,
              page: 1,
              begintime: moment(this.rowAlarm.lAlarmStartTime)
                .subtract(6, "seconds")
                .format("YYYY-MM-DD HH:mm:ss"), //"2024-04-27 00:00:00", //moment().format("YYYY-MM-DD 00:00:00"),
              endtime: moment(this.rowAlarm.bj_sj)
                .add(8, "seconds")
                .format("YYYY-MM-DD HH:mm:ss"), //"2024-04-27 23:00:00", //moment().format("YYYY-MM-DD 23:59:59"),
              dev_ids: this.rowAlarm.dev_id,
            };

            query_list.type_id = 2000;

            this.$api.search_media_file_list_by_ids(query_list).then((res) => {
              let ay = [];
              if (res.data.data) {
                let msg, ay_msg, ay_alarm, img_p, video_p;
                res.data.data.forEach((it) => {
                  msg = it.mAlarmMsg;
                  ay_alarm = [];
                  if (msg != null) {
                    ay_msg = msg.split(",");
                    ay_msg.forEach((im) => {
                      ay_alarm.push(this.$t("map.e_" + im));
                    });
                  }
                  img_p =
                    this.$imgUrl +
                    it.mMediaUrl +
                    "/" +
                    (it.mMediaFileName.charAt(0) == "/"
                      ? it.mMediaFileName.substring(1)
                      : it.mMediaFileName);
                  if (it.mMediaFileName.indexOf("mp4") > -1) {
                    img_p =
                      this.$imgUrl +
                      it.mMediaUrl +
                      "/" +
                      (it.mMediaImageFileName.charAt(0) == "/"
                        ? it.mMediaImageFileName.substring(1)
                        : it.mMediaImageFileName);
                  }
                  video_p =
                    this.$imgUrl +
                    it.mMediaUrl +
                    "/" +
                    (it.mMediaFileName.charAt(0) == "/"
                      ? it.mMediaFileName.substring(1)
                      : it.mMediaFileName);
                  ay.push({
                    cph: it.cph,
                    time: it.mMediaTime,
                    alarm: ay_alarm.join(","),
                    ch: it.mChannelNo,
                    cpy: it.cName,
                    addr: "",
                    filename: it.mMediaFileName,
                    lng: it.mLongitude,
                    lat: it.mLatitude,
                    img: img_p,
                    path: video_p,
                    type:
                      it.mMediaFileName.indexOf("mp4") > -1 ? "video" : "img",
                  });
                });
              }

              this.imgList = ay;
              this.total = res.data.pagination.totalRecords;
            });
          } else {
            this.$alert("Offline");
          }
        });
    },
    clickImg() {
      this.item_idx = 5;
      this.show_flag = "img";
      this.imgList.splice(0);

      let query_list = {
        rp: 35,
        page: 1,
        begintime: moment(this.rowAlarm.lAlarmStartTime)
          .subtract(6, "seconds")
          .format("YYYY-MM-DD HH:mm:ss"), // this.rowAlarm.gps_time  "2024-04-27 00:00:00", //moment().format("YYYY-MM-DD 00:00:00"),
        endtime: moment(this.rowAlarm.bj_sj)
          .add(8, "seconds")
          .format("YYYY-MM-DD HH:mm:ss"), //"2024-04-27 23:00:00", //moment().format("YYYY-MM-DD 23:59:59"),
        dev_ids: this.rowAlarm.dev_id,
      };

      query_list.type_id = 1000;

      // this.imgList.splice(0);

      this.$api.search_media_file_list_by_ids(query_list).then((res) => {
        let ay = [];
        if (res.data.data) {
          let msg, ay_msg, ay_alarm;
          res.data.data.forEach((it) => {
            msg = it.mAlarmMsg;
            ay_alarm = [];
            if (msg != null) {
              ay_msg = msg.split(",");
              ay_msg.forEach((im) => {
                ay_alarm.push(this.$t("map.e_" + im));
              });
            }
            ay.push({
              cph: it.cph,
              time: it.mMediaTime,
              alarm: ay_alarm.join(","),
              ch: it.mChannelNo,
              cpy: it.cName,
              addr: "",
              filename: it.mMediaFileName,
              lng: it.mLongitude,
              lat: it.mLatitude,
              path:
                this.$imgUrl +
                it.mMediaUrl +
                "/" +
                (it.mMediaFileName.charAt(0) == "/"
                  ? it.mMediaFileName.substring(1)
                  : it.mMediaFileName),
              type: it.mMediaFileName.indexOf("mp4") > -1 ? "video" : "img",
            });
          });
        }

        this.imgList = ay;
        this.total = res.data.pagination.totalRecords;
      });
    },
    clickPos() {
      this.item_idx = 1;
      this.item_idx_sub = 1;
      this.show_flag = "map";
      if (this.$refs.historyMap) {
        if (this.$refs.historyMap) {
          this.$refs.historyMap.clearAll();
        }
        this.$refs.historyMap.addMarker({
          id: this.rowAlarm.id,
          lng: this.rowAlarm.lng,
          lat: this.rowAlarm.lat,
          html:
            "<b>" +
            this.$t("map.track_cph") +
            "：</b>" +
            this.rowAlarm.cph +
            "<br><b>" +
            this.$t("map.track_sj") +
            "：</b>" +
            this.rowAlarm.gps_time,
          icon: getHTTPURL() + "public/tree/dxtree/alarm.png",
        });
      } else {
        setTimeout(() => {
          this.clickPos();
        }, 1000);
      }
    },
    clickMap(num) {
      this.item_idx = 1;
      this.item_idx_sub = 2;
      this.show_flag = "map";
      if (this.$refs.historyMap) {
        this.$refs.historyMap.clearAll();
      }
      // this.dataHistory.splice(0);
      this.$api
        .search_track_grid({
          page: 1,
          rp: 5000,
          deviceid: this.rowAlarm.dev_id,
          sdate: moment(this.rowAlarm.gps_time)
            .subtract(num, "minutes")
            .format("YYYY-MM-DD HH:mm:ss"),
          edate: this.rowAlarm.gps_time,
          cph: this.rowAlarm.cph,
        })
        .then((res) => {
          this.dataHistory = res.data.data;
          //地图经纬度
          let ay = [];
          this.dataHistory.forEach((it) => {
            if (it.pLatitude != 0 && it.pLongitude != 0)
              // ay.push([parseFloat(it.pLatitude), parseFloat(it.pLongitude)]);
              ay.push({
                lat: parseFloat(it.pLatitude),
                lng: parseFloat(it.pLongitude),
                time: it.pGpsTime,
                ang: parseFloat(it.pDirection),
                cph: it.cph,
              });
          });
          this.$refs.historyMap.drawCarRoad(ay);
          // console.log(ay);
        });
    },
    get_video_url(sn) {
      let video_ip_play = this.$store.getters.videoIp; //"test.cnms365.com";
      let video_port_play = this.$store.getters.videoPort; //4022;
      return (
        "https://" +
        video_ip_play +
        ":4022/flv?port=10077&app=live&stream=" +
        sn +
        "_channel_" +
        this.channel_id +
        "_playback"
      );
      // return (
      //   "https://" +
      //   video_ip_play +
      //   ":" +
      //   video_port_play +
      //   "/flv?port=10077&app=live&stream=" +
      //   sn +
      //   "_channel_" +
      //   this.channel_id
      // );
    },
    clickBack() {
      this.item_idx = 3;
      this.show_flag = "back";
      this.channel_prev = 0;
      console.log(this.rowAlarm);
      let ay_para = this.rowAlarm.channels.split(",");
      this.ay_para = ay_para;
    },
    clickCH(num) {
      this.$api
        .tree_isOnline_device({ device_id: this.rowAlarm.dev_id })
        .then((res_online) => {
          if (res_online.data.st > 0) {
            //回放视频
            let sn = this.rowAlarm.dev_name;
            let video_ip = this.$store.getters.videoIp; //"www.xilihuala.top";
            let video_port = this.$store.getters.videoPlaybackPort; //"9500";

            let sn_org = sn;
            sn = this.leftZeroPadding(sn, 11);

            if (this.channel_prev > 0) {
              GpsSocket.sendMsg("order", {
                deviceid: sn_org,
                order: "9202",
                content: this.channel_prev + ",2,0,000000000000",
              });
            }
            this.channel_prev = num;

            let e_time = this.rowAlarm.gps_time;
            let s_time = moment(this.rowAlarm.gps_time)
              .subtract(10, "seconds")
              .format("YYYY-MM-DD HH:mm:ss");

            let channel = num; //parseInt(obj.ch);
            this.channel_id = num;
            let st = s_time
              .replace(/-/g, "")
              .replace(/:/g, "")
              .replace(/ /g, "")
              .substr(2);
            let et = e_time
              .replace(/-/g, "")
              .replace(/:/g, "")
              .replace(/ /g, "")
              .substr(2);
            this.is_play = true;
            GpsSocket.sendMsg("order", {
              deviceid: sn_org /*"018124567840"*/,
              order: "9201",
              content:
                video_ip +
                "," +
                video_port +
                ",0," +
                channel +
                ",0,1,1,0,0," +
                st +
                "," +
                et +
                "",
            });

            let url = this.get_video_url(sn);
            console.log(url, this.$refs.video);
            setTimeout(() => {
              this.$refs.video.playUrl(url);
            }, 1000);
          } else {
            this.$alert("Offline");
          }
        });
    },
    // clickMap() {

    // },
    clickEchart() {
      let num = 10;
      this.item_idx = 2;
      this.show_flag = "echart";
      // this.init_echart([], []);
      this.$api
        .search_track_grid({
          page: 1,
          rp: 5000,
          deviceid: this.rowAlarm.dev_id,
          sdate: moment(this.rowAlarm.gps_time)
            .subtract(num, "minutes")
            .format("YYYY-MM-DD HH:mm:ss"),
          edate: this.rowAlarm.gps_time,
          cph: this.rowAlarm.cph,
        })
        .then((res) => {
          this.dataHistory = res.data.data;
          //地图经纬度
          let ay_dt = [];
          let ay_dd = [];

          this.dataHistory.forEach((it) => {
            ay_dt.push(it.pGpsTime);
            ay_dd.push(parseFloat(it.pSpeed_val) * 0.1);
          });
          this.init_echart(ay_dt, ay_dd);
        });
    },
    init_echart(dt, dd) {
      var myChart = echarts.init(document.getElementById("main"));
      console.log("myChart", myChart);
      var option = {
        xAxis: {
          type: "category",
          data: dt.reverse(),
          axisLabel: {
            rotate: 50, //倾斜角度
            //rotate: -50 向右转
          },
        },
        yAxis: {
          type: "value",
        },
        grid: {
          containLabel: true,
          left: "0%",

          right: "0%",
        },
        color: ["#5a72e0"],
        series: [
          {
            data: dd.reverse(),
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    clickOk() {},
    init_data() {
      GpsSocket.addListener((data) => {
        if (data.type == "answer") {
          // let url = this.get_video_url(this.rowAlarm.dev_name);
          // console.log(url, this.$refs.video);
          // setTimeout(() => {
          //   this.$refs.video.playUrl(url);
          // }, 1000);
        }
      });
      if (this.show_flag == "map") {
        this.$nextTick(() => {
          // console.log(this.$refs.historyMap);
          this.$refs.historyMap.$refs.mapRef.loadScripts();
        });
      }
      this.$nextTick(() => {
        // this.init_echart();
      });

      // this.$api
      //   .sys_ckfj_grid({
      //     aaAlarmGuid: "6da455d401844ccbac3658cc8ae6615e",
      //     aaAlarmTime: "2024-05-09 15:57:47",
      //   })
      //   .then((res) => {
      //     if (res.data.data) {
      //       res.data.data.forEach((it) => {
      //         if (it.aaFileName.indexOf("mp4") > -1) {
      //           this.videoPath =
      //             this.$imgUrl + it.aaFileUrl + "/" + it.aaFileName;
      //           this.videoName = it.aaFileName;
      //         } else {
      //           this.imgList.push({
      //             path: this.$imgUrl + it.aaFileUrl + "/" + it.aaFileName,
      //             filename: it.aaFileName,
      //           });
      //         }
      //       });
      //     }
      //     console.log(res);
      //   });
    },
    clickFun(flag, obj = {}) {
      this.$emit("ErpDialogEvent", Object.assign({ type: flag }, obj));
    },
  },
};
</script>

<style lang="scss" scoped>
.imgList {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .img-it {
    box-sizing: border-box;
    padding: 2px;
    width: 165px;
    height: 100px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.title {
  box-sizing: border-box;
  height: 35px;
  line-height: 35px;

  padding-left: 5px;
  font-size: 16px;
  color: #409eff;
  margin-bottom: 15px;
  margin-top: -25px;
}
.title span {
  color: #409eff;
}
.navMain {
  display: flex;
  flex-direction: row;
  font-size: 16px;

  .nav-l {
    width: 200px;
    line-height: 20px;
    background: #f9fbff;
    border: 1px solid #ecf1fa;
    padding: 10px;
  }
  .nav-r {
    flex: 1;
    //height: calc(100vh - 300px);
    margin-left: 5px;
    border: 1px solid #ecf1fa;
    .nav-row {
      display: flex;
      flex-direction: row;
      .ch {
        padding-left: 10px;
      }
      .ch2 {
        padding-left: 10px;
      }
    }
  }
  li {
    list-style: none;
    cursor: pointer;
  }
}

::v-deep .title {
}
::v-deep .item {
  padding: 5px 0px;
  line-height: 30px;
  border-bottom: 1px solid #eee;
  font-size: 15px;
}
::v-deep .item ul {
  padding-left: 10px;
}
::v-deep .item span {
  color: #409eff;
  margin-right: 3px;
  font-size: 20px;
}
.mt20 {
  margin-top: 20px;
}
.mt50 {
  margin-top: 40px;
}
.ch {
  cursor: pointer;
  text-align: center;
  width: 130px;
  border-radius: 5px;
  font-size: 14px;
  background: #f0f5ff;
  border: 1px solid #dae2f0;
  height: 35px;
  line-height: 35px;
  color: #000;
  margin-bottom: 10px;
  margin-left: 25px;
  margin-right: 5px;
}
.ch2 {
  cursor: pointer;
  text-align: center;
  width: 130px;
  border-radius: 5px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #dae2f0;
  height: 35px;
  line-height: 35px;
  color: #000;
  margin-bottom: 10px;
  margin-left: 25px;
  margin-right: 50px;
}
.aa {
  margin-top: 9%;
}
.act {
  color: #409eff;
}

.Window_container {
  position: fixed;
  min-width: 700px;
  background: #fff;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  font-size: 12px;
  left: 50%;
  top: 100px;
  // transform: translate(-50%, 0);
  .Window_window_title {
    background: url(data:image/png;base64,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)
      no-repeat 100%;
    cursor: move;
    .Window_title {
      line-height: 40px;
      padding-left: 10px;
      color: #fff;
      font-size: 13px;
      user-select: none;
      overflow: hidden;
      width: calc(100% - 50px);
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-user-select: none;
      -ms-user-select: none;
      -moz-user-select: none;
    }
    .Window_closebtn,
    .Window_fullScreenbtn {
      color: #fff;
      font-size: 16px;
      float: right;
      height: 100%;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
  .Window_header {
    height: 40px;
    background-color: rgba(64, 150, 209, 1) !important;
  }
  .MediaViewingWindow_content {
    width: 100%;
    height: 100%;
    min-height: 300px;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    .swiper-button-next {
      position: absolute;
      right: 10px;
      top: 50%;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      z-index: 10;
      cursor: pointer;
      background: url(../assets/i2.png);
      background-size: 44px 44px;
      background-position: 50%;
      background-repeat: no-repeat;
    }
    .swiper-button-prev {
      position: absolute;
      left: 10px;
      top: 50%;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      z-index: 10;
      cursor: pointer;
      background: url(../assets/i1.png);
      background-size: 44px 44px;
      background-position: 50%;
      background-repeat: no-repeat;
    }
  }
  // .MediaViewingWindow_img {
  //   margin: auto;
  //   position: relative;
  // }
  .MediaViewingWindow_details {
    position: relative;
    bottom: 1px px;
    width: 100%;
    text-align: left;
    float: left;
    .MediaViewingWindow_table {
      width: 100%;
      border-collapse: collapse;
      table-layout: inherit;
      margin-bottom: -1px;
      min-width: 500px;
      font-size: 13px;
      td {
        border: 1px solid;
        height: 34px;
        padding: 0 10px;
      }
    }
    .MediaViewingWindow_tableName {
      width: 50px;
      text-align: center;
      border-right: none;
    }
  }
  .Window_footer_PRMYT {
    background-color: #f0f1f3;
    border-top: 1px solid #d6d6d6;
    min-height: 40px;
    text-align: center;
    .sy_button {
      border-radius: 0;
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      text-align: center;
      border-style: solid;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      line-height: normal;
    }
    .sy_button_primary {
      color: #fff;
      border-color: rgba(64, 150, 209, 1);
      background-color: rgba(64, 150, 209, 1);
    }
  }
}
.act .item_sub {
  color: #333 !important;
}
.act .sub_act {
  color: #409eff !important;
}
::v-deep #container {
  height: calc(100vh - 210px);
}
::v-deep .g-map {
  height: calc(100vh - 210px) !important;
}
::v-deep .gm-style .gm-style-iw-c {
  width: 350px;
  line-height: 25px;
}
::v-deep .gm-style-iw-d b {
  font-weight: bold;
  color: #000;
}
::v-deep .gm-style-iw-chr {
  height: 30px;
}
.viv {
  position: relative;
}
.viv1 {
  position: absolute;
  left: 43%;
  top: 36%;
}
.ch1 {
  display: flex;
  margin-right: 10px;
}
</style>
